import React from 'react';
import styles from './BoxButton.module.css';

const BoxButton = ({
  icon, handleClick, userId, processed, node,
}) => (
  <i
    className={`${icon} ${styles.icon} ${processed ? styles.processed : styles.unprocessed}`}
    onClick={() => handleClick(userId)}
    ref={node}
  />
);

export default BoxButton;



// WEBPACK FOOTER //
// ./src/components/BoxButton/BoxButton.js